var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _ellipse, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHello({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 773.51 528.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-4{fill:#1e1e1c;}.cls-1,.cls-2{stroke:#1e1e1c;stroke-miterlimit:10;}.cls-1{stroke-width:5.81px;}.cls-2{stroke-width:5.96px;}.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hello") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.45,271.6V173.78H103.32V271.6H36.7V34.35h66.62V126.7h76.13V34.35h66.62V271.6Z",
    transform: "translate(-33.79 -31.37)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M309,271.6V34.35H497V81.07H379.12v47.45H490.63v46.36H379.12v50.37H497.91V271.6Z",
    transform: "translate(-33.79 -31.37)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.86,551.59V314.35h64.47V505.24H201.87v46.35Z",
    transform: "translate(-33.79 -31.37)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.49,551.59V314.35H299V505.24H399.5v46.35Z",
    transform: "translate(-33.79 -31.37)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M534.4,555.24C477.47,555.24,425.56,518,425.56,433S477.47,310.7,534.4,310.7,643.24,347.93,643.24,433,591.33,555.24,534.4,555.24Zm0-196.36c-22.18,0-42.7,21.53-42.7,74.09s20.52,74.09,42.7,74.09,42.7-21.53,42.7-74.09S556.59,358.88,534.4,358.88Z",
    transform: "translate(-33.79 -31.37)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "735.44 356.55 648.24 356.21 646.01 12.72 740.92 13.08 735.44 356.55"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 727.21,
    cy: 486.47,
    rx: 58.95,
    ry: 58.4,
    transform: "translate(-43.8 -16.07) rotate(-1.2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M710.53,47l70.19.27L775.48,382.3l-62.77-.25L710.53,47M696.09,32.59l2.37,363.75,91.14.36L795.29,33l-99.2-.37Z",
    transform: "translate(-33.79 -31.37)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M745.7,454.61h.2a47.86,47.86,0,0,1,33.51,13.6,44.29,44.29,0,0,1,13.55,32c-.11,25-21.32,45.27-47.28,45.27h-.2A47.86,47.86,0,0,1,712,531.92a44.29,44.29,0,0,1-13.55-32c.11-25,21.32-45.27,47.28-45.27m0-14.34c-33.9,0-61.47,26.61-61.61,59.55s27.32,59.9,61.35,60h.25c33.91,0,61.48-26.61,61.62-59.55S780,440.4,746,440.27Z",
    transform: "translate(-33.79 -31.37)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHello);
export default __webpack_public_path__ + "static/media/Hello.273c59214a19185f0bd9b7588dcb23a2.svg";
export { ForwardRef as ReactComponent };